import { render, staticRenderFns } from "./addBack.vue?vue&type=template&id=3fd18749&scoped=true&"
import script from "./addBack.vue?vue&type=script&lang=js&"
export * from "./addBack.vue?vue&type=script&lang=js&"
import style0 from "./addBack.vue?vue&type=style&index=0&id=3fd18749&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd18749",
  null
  
)

export default component.exports